import { formatUsd } from "lib/numbers";
import { formatCngnPrice, isCngnToken } from "sdk/utils/cngnCurrency";

type TradeMarkLike = {
  source?: "executed" | "open-position";
  orderType?: number;
  executionType?: number;
  executionPrice?: string;
};

function toBigIntOrUndefined(value: string | undefined) {
  if (!value) return undefined;

  try {
    return BigInt(value);
  } catch (_error) {
    return undefined;
  }
}

export function getExecutedTradeMarkSide(
  orderType: number | undefined,
  isLong: boolean | undefined
): "B" | "S" | undefined {
  if (typeof orderType !== "number" || typeof isLong !== "boolean") {
    return undefined;
  }

  const isIncrease = orderType === 2 || orderType === 3;
  const isDecrease = orderType === 4 || orderType === 5 || orderType === 6;

  if (!isIncrease && !isDecrease) {
    return undefined;
  }

  if (isIncrease) {
    return isLong ? "B" : "S";
  }

  return isLong ? "S" : "B";
}

export function getTradeMarkPriceLabel(mark: TradeMarkLike | undefined) {
  return mark?.source === "open-position" ? "Entry Price" : "Execution Price";
}

export function getTradeMarkOrderType(mark: TradeMarkLike | undefined) {
  return mark?.orderType;
}

export function getTradeMarkExecutionType(mark: TradeMarkLike | undefined) {
  return mark?.executionType;
}

export function formatTradeMarkPrice(
  mark: TradeMarkLike | undefined,
  params: {
    symbol: string;
    displayDecimals?: number;
    visualMultiplier?: number;
  }
) {
  const price = toBigIntOrUndefined(mark?.executionPrice);
  if (price === undefined) {
    return "-";
  }

  if (mark?.source === "open-position") {
    const displayDecimals = isCngnToken(params.symbol) ? 2 : params.displayDecimals;

    return (
      formatCngnPrice(price, params.symbol, {
        displayDecimals,
        visualMultiplier: params.visualMultiplier,
      }) ??
      formatUsd(price, {
        displayDecimals,
        visualMultiplier: params.visualMultiplier,
      })
    );
  }

  return formatUsd(price);
}
